const SEND_CONTACT_FORM_SUCCESS = 'SEND_CONTACT_FORM_SUCCESS';
const SEND_CONTACT_FORM_ERROR = 'SEND_CONTACT_FORM_ERROR';

export default {
  SEND_CONTACT_FORM_SUCCESS,
  SEND_CONTACT_FORM_ERROR

};
